var _style, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61.6 51.1",
    style: {
      enableBackground: "new 0 0 61.6 51.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.2669,
    y1: 25.633,
    x2: 26.957,
    y2: -5.1122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE73C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05179971,
    style: {
      stopColor: "#FB6CC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2542,
    style: {
      stopColor: "#F154BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#EA43B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7057,
    style: {
      stopColor: "#E539B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E436B1"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25.3,0 17,32.2 28.4,28.2 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.6118,
    y1: 37.6367,
    x2: 74.4164,
    y2: 47.1995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CD2597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1695,
    style: {
      stopColor: "#DF439F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3467,
    style: {
      stopColor: "#ED5BA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5356,
    style: {
      stopColor: "#F76CAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7423,
    style: {
      stopColor: "#FD76AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF79AE"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,39.4 17,32.2 61.6,51.1 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.6827,
    y1: 41.4688,
    x2: 20.7252,
    y2: 11.47
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001126454,
    style: {
      stopColor: "#FE73C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1446,
    style: {
      stopColor: "#EF5BB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E043A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5217,
    style: {
      stopColor: "#D5329F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    style: {
      stopColor: "#CF2899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CD2597"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "25.3,0 0,39.4 17,32.2 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.1154,
    y1: 32.4895,
    x2: 67.7237,
    y2: 48.3123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF85CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09800994,
    style: {
      stopColor: "#FF9DD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2506,
    style: {
      stopColor: "#FFBBE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4113,
    style: {
      stopColor: "#FFD3F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#FFE4F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7677,
    style: {
      stopColor: "#FFEEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF1FE"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "61.6,51.1 28.4,28.2 17,32.2 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkArrow);
export default __webpack_public_path__ + "static/media/pink-arrow.5783f107822385eacfac8c8efe283f95.svg";
export { ForwardRef as ReactComponent };